import React from 'react';
import { CloseOutlined } from '@ant-design/icons';
import {
  SectionCard,
  SectionHeader,
  SectionTitle,
  CloseButton,
  AnnouncementsList,
  AnnouncementItem,
  AnnouncementText,
  StyledCollapse,
} from './styles';
import { AnnouncementsSectionProps } from './types';

const { Panel } = StyledCollapse;

const AnnouncementsSection: React.FC<AnnouncementsSectionProps> = ({
  announcements,
  isOpen,
  onClose,
}) => {
  return (
    <StyledCollapse activeKey={isOpen ? ['announcements'] : []} ghost expandIcon={() => null}>
      <Panel key="announcements" header={null}>
        <SectionCard>
          <SectionHeader>
            <SectionTitle level={4}>Announcements</SectionTitle>
            <CloseButton
              type="text"
              icon={<CloseOutlined />}
              onClick={onClose}
              aria-label="Close"
            />
          </SectionHeader>
          <AnnouncementsList>
            {announcements.map((announcement, index) => (
              <AnnouncementItem key={index}>
                <AnnouncementText>{announcement.message}</AnnouncementText>
              </AnnouncementItem>
            ))}
          </AnnouncementsList>
        </SectionCard>
      </Panel>
    </StyledCollapse>
  );
};

export default AnnouncementsSection;
